import React from 'react';
import PropTypes from 'prop-types';
import { UX2, constants } from '@wsb/guac-widget-core';
import dataAids from '../../constants/dataAids';

const { NEUTRAL } = constants.categoryTypes;
const { DEFAULT } = constants.sectionTypes;

function ChatPlaceholder({ staticContent, width, height }) {
  const styles = {
    container: {
      position: 'relative',
      pointerEvents: 'none',
      backgroundColor: 'white',
      width,
      height,
      border: '1px solid #ccc'
    },
    title: {
      position: 'absolute',
      width: '100%',
      color: 'black',
      textTransform: 'uppercase',
      fontFamily: 'sans-serif',
      fontWeight: 700,
      paddingVertical: 'small',
      borderBottom: '1px solid #ccc'
    },
    content: {
      position: 'absolute',
      width: '100%',
      top: '40%'
    },
    description: {
      color: '#444',
      fontFamily: 'sans-serif',
      fontSize: '18px',
      lineHeight: '22px',
      marginHorizontal: 'large',
      marginTop: 'small'
    }
  };

  return (
    <UX2.Element.Block
      style={ styles.container }
      category={ NEUTRAL }
      section={ DEFAULT }
      data-aid={ dataAids.LIVESTREAM_CHAT_PLACEHOLDER_RENDERED }
    >
      <UX2.Element.Block style={ styles.title }>{staticContent.chatTitleEdit}</UX2.Element.Block>

      <UX2.Element.Block style={ styles.content }>
        <UX2.Element.Icon icon='uxcoreComments' width={ 96 } height={ 96 } style={{ color: 'black' }} />
        <UX2.Element.Block style={ styles.description }>
          {staticContent.chatDescriptionEdit}
        </UX2.Element.Block>
      </UX2.Element.Block>
    </UX2.Element.Block>
  );
}

ChatPlaceholder.propTypes = {
  staticContent: PropTypes.object,
  width: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
  height: PropTypes.number
};

export default ChatPlaceholder;
